import { FieldList, IRegistrationStepFactory, RegistrationStep, getRemainingSteps } from '../step';
import { mapFieldToStep } from '../fieldsMap';
import { compareSteps } from '../stepPriority';
import { StepName } from '../stepNames';

export const commonFactory: IRegistrationStepFactory = {
  createStep: (name: StepName, fields: FieldList) => {
    const stepFields: RegistrationStep['fields'] = [];
    for (const fieldName of fields) {
      const stepName = mapFieldToStep.get(fieldName);
      if (stepName !== name) {
        continue;
      }
      stepFields.push({ name: fieldName, required: true });
    }

    return {
      name,
      fields: stepFields,
    };
  },

  getStepNames: (fields: FieldList) => getRemainingSteps(fields, mapFieldToStep, compareSteps),
};
